import { Box, Dialog, DialogContent, DialogProps, Typography } from '@mui/material'
import { Icon } from 'components/icon'
import React from 'react'
import styled from 'styled-components'

const StyledModal = styled(Dialog)`
  .MuiDialogContent-root {
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export interface IModalProps extends DialogProps {
  title?:  string,
  open:    boolean,
  onClose: () => void | Promise<void>,
}

export const Modal: React.FC<IModalProps> = ({
  title,
  open,
  onClose,
  maxWidth,
  children,
  ...props
}) => {
  return (
    <StyledModal
      fullWidth
      open       = {open}
      onClose    = {onClose}
      maxWidth   = {maxWidth || 'sm'}
      PaperProps = {{
        elevation: 0,
      }}
      {...props}
    >
      <Box display="flex" justifyContent="space-between">
      {title !== undefined && <Typography variant="h5">{title}</Typography>}
      <Box sx={{cursor: 'pointer' , marginLeft: 'auto'}} >
        <Icon size='size-16' iconId = 'remove' onClick={onClose} />
      </Box>
      </Box>
      <DialogContent>
        {children}
      </DialogContent>
    </StyledModal>
  )
}
